module.exports = __webpack_public_path__ + "pg.svg?f2479bfd0b94e2e9ceb33e9e4c752628";